/* eslint-disable prefer-promise-reject-errors */
import {
    db,
    auth,
    serverTimestamp,
} from '../config/firebase';

function register(data) {
    return new Promise((resolve, reject) => {
        const {
            mail,
            password,
            acceptedRules,
            applicationId,
        } = data;
        auth()
            .createUserWithEmailAndPassword(mail, password)
            .then((user) => {
                const setCustomer = () => (
                    new Promise((resolvePromise, rejectPromise) => {
                        const collection = db.collection('customers');
                        const state = {
                            uid: user.uid,
                            mail,
                            acceptedRules,
                            applications: [
                                applicationId,
                            ],
                        };
                        collection
                            .doc(user.uid)
                            .set(state)
                            .then(() => {
                                resolvePromise();
                            })
                            .catch((error) => {
                                rejectPromise(error.message);
                            });
                    })
                );
                const updateApplication = () => (
                    new Promise((resolvePromise, rejectPromise) => {
                        const collection = db.collection('applications');
                        const state = {
                            customer: {
                                uid: user.uid,
                                mail,
                            },
                            'formStepper.activeStep': 3,
                            lastUpdate: serverTimestamp(),
                        };
                        collection
                            .doc(applicationId)
                            .update(state)
                            .then(() => {
                                resolvePromise();
                            })
                            .catch((error) => {
                                rejectPromise(error.message);
                            });
                    })
                );
                const sendEmailVerification = () => (
                    new Promise((resolvePromise, rejectPromise) => {
                        user
                            .sendEmailVerification()
                            .then(() => {
                                resolvePromise();
                            })
                            .catch((error) => {
                                rejectPromise(error.message);
                            });
                    })
                );
                Promise
                    .all([
                        setCustomer(),
                        sendEmailVerification(),
                        updateApplication(),
                    ])
                    .then(() => {
                        resolve({
                            uid: user.uid,
                            mail,
                        });
                    })
                    .catch((error) => {
                        reject(error);
                    });
            })
            .catch((error) => {
                reject({
                    message: error.message,
                    mail,
                });
            });
    });
}

export default register;



// WEBPACK FOOTER //
// ./src/service/register.js